import { rgba } from 'polished';
import styled from 'styled-components';
import Typography from '../../styles/Typography';

export const StyledBalanceBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: 1.5rem;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.light};
  border: 1px solid ${({ theme }) => theme.colors.background.medium};
  border-radius: 0.875rem;
  padding: 1.5rem 1.5rem;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  position: relative;
  overflow: hidden;
  transition: box-shadow 220ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 220ms cubic-bezier(0.4, 0, 0.2, 1),
    border-color 220ms cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 1.5rem;
    right: 1.5rem;
    height: 2px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.brand.green},
      ${({ theme }) => theme.colors.brand.yellow}
    );
    border-radius: 0 0 2px 2px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px -6px rgba(9, 15, 56, 0.12),
      0 2px 4px -1px rgba(16, 24, 40, 0.04);
    border-color: ${({ theme }) => rgba(theme.colors.brand.yellow, 0.5)};
  }
`;

export const StyledBalanceBoxIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 0.625rem;
  background: ${({ theme }) =>
    `linear-gradient(135deg, ${rgba(
      theme.colors.brand.yellow,
      0.22
    )}, ${rgba(theme.colors.brand.yellow, 0.08)})`};
  color: ${({ theme }) => theme.colors.brand.navy};
  margin-bottom: 1rem;

  svg {
    height: 1.25rem;
    width: 1.25rem;
    fill: currentColor;
  }
`;

export const StyledBalanceBoxTitle = styled(Typography).attrs({
  variant: 'caption',
})`
  color: ${({ theme }) => rgba(theme.colors.text.secondary, 0.7)};
  font-size: 0.6875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-top: 0.5rem;
`;
